<template>
  <div>
    <v-row class="mx-1">
      <v-col class="display-1 font-weight-bold">Related Course</v-col>
    </v-row>
    <v-row class="mb-7">
      <v-col lg="12">
        <v-toolbar flat style="background:transparent">
          <div class="mr-md-5 xs-full-width mt-7">
            <p class="mb-2 caption font-weight-medium text-caption">SEARCH</p>
            <v-text-field
              outlined
              v-model="searchdata"
              @change="searchInfo(searchdata)"
              :placeholder="$vuetify.lang.t('$vuetify.courseManagement.search')"
              clearable
              background-color="#fff"
              height="40"
            ></v-text-field>
          </div>
          <div class="hiddex-xs mt-7">
            <v-btn class="pl-5 pr-5 btn-reload body-2" height="40" @click="initialize">
              <v-icon left>mdi-cached</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
            </v-btn>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <div class="body-table px-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :page.sync="params.page"
        :items-per-page="limit"
        @page-count="pageCount"
        hide-default-footer
        :items="courses"
        class="page-card font-weight-light"
        elevation="3"
      >
        <template v-slot:item.image="{ item }">
          <v-img :src="item.image" class="my-2 rounded-card" width="120" aspect-ratio="1.7"></v-img>
        </template>
        <template v-slot:item.title="{ item }">
          <p class="ma-2 md-fixed-width body-2 font-weight-light text-left">{{item.title}}</p>
        </template>
        <template v-slot:item.ownerCourse="{ item }">
          <div v-for="ownerCourse in item.ownerCourse" :key="ownerCourse._id._id">
            <p class="ma-2 xs-fixed-width body-2 font-weight-light">{{ownerCourse._id.displayName}}</p>
          </div>
        </template>
        <template v-slot:item.category="{ item }">
          <div v-for="category in item.category" :key="category._id">
            <p class="mb-0 body-2 font-weight-light">{{category.title}}</p>
          </div>
        </template>
        <!-- <template v-slot:item.price="{ item }">
          <v-row class="border-bottom" v-for="price in item.price" :key="price._id">
            <p
              class="my-2 full-width text-center"
            >{{price.pricing==0 ? $vuetify.lang.t('$vuetify.courseManagement.courseList.free') : `${Number(price.pricing).toLocaleString()} ${$vuetify.lang.t('$vuetify.courseManagement.courseList.baht')}`}}</p>
          </v-row>
        </template>-->

        <template v-slot:item.edit="{ item }">
          <div class="d-flex justify-center">
            <v-btn
              v-if="item.permissionEdit == true"
              elevation="0"
              class="mb-0 body-2 text-primary text-capitalize"
              color="white"
              @click="item.permissionEdit == true ? editItem(item) : noPermission()"
            >
              <p class="mb-0">{{$vuetify.lang.t('$vuetify.courseManagement.courseList.edit')}}</p>
            </v-btn>
            <!-- <p v-if="item.permissionEdit == false">ไม่สามารถแก้ไขได้</p> -->
            <v-divider v-if="item.permissionEdit == true" inset vertical class="mb-2 mx-1"></v-divider>
            <div v-if="item.permissionEdit == false" class="ml-12 pl-6"></div>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  elevation="0"
                  class="mb-0 body-2 text-primary text-capitalize"
                  color="white"
                  v-on="on"
                >
                  <p
                    class="mb-0 mr-1"
                  >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.more')}}</p>
                  <v-icon small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="setChooseSection(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-cog-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-light subtitle-2"
                    >{{$vuetify.lang.t("$vuetify.courseManagement.courseList.studentManagement")}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item link @click="setViewReport(item)">
                  <v-list-item-icon class="mr-2">
                    <v-icon small>mdi-text-box-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="font-weight-light subtitle-2"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.viewReport')}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip outlined class="ma-2" :color="item.active==0 ?'red':'green'">
            <v-avatar left>
              <v-icon x-small>mdi-checkbox-blank-circle</v-icon>
            </v-avatar>
            <p class="mb-0">{{item.active==0 ? 'ปิดใช้งาน' : 'เปิดใช้งาน'}}</p>
          </v-chip>
          <!-- <v-icon :color="item.active==0?'red':'green'">{{item.active==0?'clear':'done'}}</v-icon> -->
        </template>
        <!-- <template v-slot:item.report="{ item }">
          <v-chip outlined class="mb-0 white--text" color="blue-grey" @click="setChooseRoom(item)">
            <v-avatar left>
              <v-icon>mdi-call-made</v-icon>
            </v-avatar>
            <p class="mb-0">ดูรายงาน</p>
          </v-chip>
        </template>-->

        <!-- <template v-slot:item.edit="{ item }">
          <v-chip
            v-if="item.permissionEdit == true"
            outlined
            class="mb-0 white--text"
            color="blue-grey"
            @click="item.permissionEdit == true ? editItem(item) : noPermission()"
          >
            <v-avatar left>
              <v-icon>mdi-pencil</v-icon>
            </v-avatar>
            <p class="mb-0">แก้ไข</p>
          </v-chip>
          <p v-if="item.permissionEdit == false">ไม่สามารถแก้ไขได้</p>
        </template>-->
        <!-- <template v-slot:item.actions="{ item }">
          <v-chip outlined class="mb-0 white--text" color="blue" @click="setChooseSection(item)">
            <v-avatar left>
              <v-icon>mdi-account-multiple</v-icon>
            </v-avatar>
            <p class="mb-0">จัดการผู้เรียน</p>
          </v-chip>
        </template>-->
        <!-- <template v-slot:item.actions="{ item }"> -->
        <!-- <v-icon small class="mr-2" @click="openUserModal(item)">mdi-account-multiple</v-icon>!-->
        <!-- <v-icon small class="mr-2" @click="openSectionModal(item)">mdi-account-multiple</v-icon>
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>-->
        <!-- <v-icon small @click="openModal(item)">mdi-delete</v-icon> -->
        <!-- </template> -->
      </v-data-table>
    </div>
    <v-dialog v-model="deleteDialog" max-width="350">
      <v-card class="pt-10">
        <!-- <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title> -->

        <v-card-text>Are you sure you want to delete this item?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="deleteDialog = false">cancel</v-btn>

          <v-btn color="green darken-1" text @click="deleteItem">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="alert" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">ขออภัย</v-card-title>
          <v-card-text>
            คุณไม่สามารถใช้งานฟังก์ชันนี้ได้ เนื่องจากไม่มีการ
            <strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alert = false">ตกลง</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="registerTutoralert" persistent max-width="450">
        <v-card>
          <div class="text-right">
            <v-btn icon class="ml-auto" @click="registerTutoralert = false">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div v-show="isTeacher=='n'">
              คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากไม่มีการ
              <strong>&nbsp;กำหนดสิทธิ์&nbsp;</strong>การเข้าถึงให้กับบัญชีผู้ใช้ของคุณ
              <strong>&nbsp;สมัครเป็นครู&nbsp;</strong> เพื่อเข้าถึงรายการนี้
              <div class="text-center mt-10">
                <v-btn rounded color="primary" @click="openConfirmDialog" dark>สมัครเป็นครู</v-btn>
              </div>
            </div>
            <div v-show="isTeacher=='r'">
              การ
              <strong>&nbsp;สมัครเป็นครู&nbsp;</strong>ของบัญชีนี้
              <strong class="red--text">&nbsp;ไม่สำเร็จ&nbsp;</strong>
              <br />
              <br />
              <strong style="text-decoration:underline">เนื่องจาก</strong>
              &nbsp;
              {{reject_note}}
              <br />
              <br />กรุณา
              <strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ใหม่อีกครั้งเพื่อสามรถเข้าถึงรายการนี้
              <div class="text-center mt-10">
                <v-btn rounded color="primary" @click="openConfirmDialog" dark>สมัครเป็นครู</v-btn>
              </div>
            </div>
            <div v-show="isTeacher=='w'" class="mb-10">
              <v-card-title class="headline">ขออภัย</v-card-title>คุณไม่สามารถเข้าถึงรายการนี้ได้ เนื่องจากการ
              <strong>&nbsp;สมัครเป็นครู&nbsp;</strong> ของบัญชีนี้ยังไม่ได้รับการยืนยัน
              กรุณารอ
              <strong>&nbsp;การยืนยัน&nbsp;</strong> จาก admin
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="selectSectionDialog" max-width="600">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>เลือกกลุ่มเรียน</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeSectionModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container fluid class="my-5">
          <v-data-table
            :headers="section_headers"
            :items="section_data"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            class="boder elevation-0"
            @page-count="pageCount = $event"
          >
            <template v-slot:item.teacher="{ item }">
              <p class="ma-0">{{item.teacher.displayName}}</p>
            </template>
            <template v-slot:item.select="{ item }">
              <!-- <v-icon small class="mr-2" @click="userEdit(item)">mdi-pencil</v-icon> -->
              <v-chip
                outlined
                class="mb-0 white--text"
                :color="chooseRoom == true ? 'blue-grey' : 'blue'"
                @click="chooseRoom == true ? openDialogGetReport(item) :openUserModal(item)"
              >
                <v-avatar left>
                  <v-icon>{{(chooseRoom == true) ? 'mdi-call-made' : 'mdi-plus'}}</v-icon>
                </v-avatar>
                <p class="mb-0">{{(chooseRoom == true) ? 'ดูรายงาน' : 'เพิ่มผู้เรียน'}}</p>
              </v-chip>
            </template>
          </v-data-table>
          <!--<div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>-->
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" rounded dark @click="closeSectionModal">ปิด</v-btn>
          <!-- <v-btn color="green darken-1" text @click="openUserModal">OK</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <import-user-dialog
      :isOpen.sync="userDialog"
      :isClose="CloseUserModal"
      :courseId.sync="manageUserCourseID"
      :sectionID.sync="roomID"
    ></import-user-dialog>
    <confirm-tutor-dialog :isOpen.sync="confirmDialog" :isClose="closeConfirmDialog"></confirm-tutor-dialog>
    <v-row justify="center">
      <v-dialog
        v-model="dialogFullReport"
        fullscreen
        persistent
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-finance</v-icon>
              {{$vuetify.lang.t('$vuetify.courseManagement.courseList.studentListInCourse')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialogFullReport">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <div>
              <v-row>
                <v-col
                  class="display-1 font-weight-medium black--text mx-5 mt-5"
                >Learner List of the Course</v-col>
              </v-row>
              <v-row class="pa-5 pt-0 mt-0 pb-0 mb-0 align-center">
                <v-col cols="2" class="pt-0 mt-0">
                  <v-card max-width="200">
                    <v-img
                      class="rounded-card"
                      height="100"
                      :src="imageCourse == null ? imageReady : imageCourse"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center">
                          <v-icon
                            v-if="imageReady"
                            class="my-2 rounded-card"
                            elevation="3"
                            size="80"
                          >mdi-image-area</v-icon>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </v-col>
                <v-col>
                  <v-col class="headline black--text py-0">{{ title }}</v-col>
                  <v-col class="subtitle-1 font-weight-medium pb-1">
                    <span class="black--text">Instructor:</span>
                    <span class="font-weight-light ml-3 font-italic">{{ instructorName }}</span>
                  </v-col>
                  <v-col class="subtitle-1 font-weight-medium py-0 d-flex">
                    <span class="black--text mt-1">Group:</span>
                    <v-col class="subtitle-2 font-weight-light py-0 ml-3" cols="3">
                      <v-select
                        :items="roomsCourse"
                        v-model="selectedRoom"
                        outlined
                        background-color="#fff"
                        height="40"
                        @change="onChangeRoom()"
                      ></v-select>
                    </v-col>
                  </v-col>
                </v-col>
              </v-row>
              <v-row>
                <v-toolbar flat style="background:transparent" color="table-header pa-0">
                  <v-col cols="3" class="ma-md-5 px-0 xs-full-width">
                    <span class="caption title-text font-weight-black">SEARCH</span>
                    <v-text-field
                      class="text-field-border"
                      solo
                      flat
                      dense
                      v-model="searchdataStudent"
                      @change="searchInfoStudent(searchdataStudent)"
                      :placeholder="$vuetify.lang.t('$vuetify.courseManagement.search')"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <div class="mr-md-3 ml-7">
                    <div class="mr-md-5 xs-full-width">
                      <div class="caption font-weight-black title-text">STATUS</div>
                      <v-btn-toggle
                        color="primary accent-3"
                        background-color="white"
                        mandatory
                        v-model="status_student_toggle"
                        @change="applyStudentFilter"
                      >
                        <v-btn class="text-capitalize body-2 px-12" height="40px">All</v-btn>
                        <v-btn
                          class="text-capitalize body-2 px-8"
                          height="40px"
                        >Started ({{countStartedStudents.length}})</v-btn>
                        <v-btn
                          class="text-capitalize body-2 px-3"
                          height="40px"
                        >Not Started ({{countNotStartedStudents.length}})</v-btn>
                      </v-btn-toggle>
                    </div>
                  </div>
                  <div class="ml-5 xs-full-width mt-12">
                    <v-btn
                      height="40px"
                      elevation="0"
                      back
                      outlined
                      @click="refreshStudent"
                      class="mb-7 pl-6 pr-5 xs-full-width body-2 text-field-border"
                    >
                      <v-icon left>mdi-cached</v-icon>
                      {{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
                    </v-btn>
                  </div>
                </v-toolbar>
                <v-col lg="12" md="12" cols="12">
                  <v-data-table
                    :loading="loading"
                    :headers="headerStudents"
                    :page.sync="page_student"
                    :items-per-page="limit_student"
                    @page-count="pageCount_student"
                    hide-default-footer
                    :items="reportStudentList"
                    class="ma-md-5 pt-0 mt-0 font-weight-light"
                    elevation="3"
                  >
                    <template v-slot:item.image="{ item }">
                      <v-img
                        :src="item.image == null ? imageReady : item.image"
                        class="my-2 ml-auto mr-auto rounded-card img-md"
                        aspect-ratio="1"
                        width="60"
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-icon
                              v-if="imageReady"
                              class="mx-auto"
                              elevation="3"
                              size="65"
                            >mdi-account</v-icon>
                          </v-row>
                        </template>
                      </v-img>
                      <!-- </v-avatar> -->
                    </template>
                    <template v-slot:item.fullName="{ item }">
                      <p
                        class="ma-2 ml-0 md-fixed-width text-left subtitle-2 font-weight-light"
                      >{{item.fullName}}</p>
                    </template>
                    <template v-slot:item.progress="{ item }">
                      <div v-if="item.percent == 100" class="d-flex align-center">
                        <v-progress-linear
                          :value="item.percent"
                          color="success lighten-1"
                          rounded
                          height="8"
                          reactive
                        ></v-progress-linear>
                        <v-icon small color="success lighten-1" class="ml-3">mdi-check-circle</v-icon>
                      </div>

                      <div v-else class="d-flex align-center">
                        <v-progress-linear
                          :value="item.percent"
                          background-color="grey lighten-4"
                          color="primary lighten-1"
                          rounded
                          height="8"
                          reactive
                        ></v-progress-linear>
                        <span class="font-weight-light subtitle-2 ml-3">{{item.percent}}%</span>
                      </div>
                    </template>
                    <template v-slot:item.report="{ item }">
                      <v-chip
                        outlined
                        label
                        small
                        class="mb-0"
                        color="primary lighten-1"
                        @click="viewProgressReport(item)"
                      >
                        <v-avatar left>
                          <v-icon small>mdi-equalizer</v-icon>
                        </v-avatar>
                        <span
                          class="mb-0"
                        >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.seeReport')}}</span>
                      </v-chip>
                    </template>
                  </v-data-table>

                  <v-row justify="center">
                    <v-dialog v-model="alert" persistent max-width="450">
                      <v-card>
                        <v-card-title
                          class="headline"
                        >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.sorry')}}</v-card-title>
                        <v-card-text>
                          <div
                            v-html="$vuetify.lang.t('$vuetify.courseManagement.courseList.alertPermissionFunction')"
                          ></div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary darken-1"
                            text
                            @click="alert = false"
                          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.ok')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                  <div class="text-center">
                    <v-pagination
                      v-model="page_student"
                      :length="pageCount_student"
                      @input="changePageStudent"
                      color="rgb(66, 154, 216)"
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>

              <v-dialog v-model="dialogFormUser" scrollable max-width="800px">
                <v-card>
                  <v-toolbar flat dark color="rgb(51, 97, 137)">
                    <v-spacer></v-spacer>
                    <v-toolbar-title
                      class="font-weight-light text-center ml-5"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.studentInformation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogFormUser = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class>
                    <v-form ref="form" v-model="valid">
                      <v-container>
                        <v-row>
                          <v-col cols="12" class="mx-auto">
                            <div class="img-padding">
                              <v-avatar :color="`grey lighten-2`" elevation="3" size="200">
                                <v-img
                                  :src="imgPreview == null ? imageReady : imgPreview"
                                  aspect-ratio="1.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-icon
                                        v-if="imageReady"
                                        class="mx-auto"
                                        elevation="3"
                                        size="200"
                                      >mdi-account</v-icon>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-avatar>
                            </div>
                            <v-divider class="mt-6"></v-divider>
                          </v-col>
                          <v-col cols="12">
                            <div
                              class="text-center display-1 font-weight-regular"
                            >{{ firstName }} {{ lastName }}</div>
                          </v-col>
                          <v-col cols="12" class="pb-0 mt-5">
                            <div class="text-center title font-weight-light">
                              <strong>{{$vuetify.lang.t('$vuetify.defaultLayout.email')}} :</strong>
                              {{ email }}
                            </div>
                          </v-col>
                          <v-col cols="12" class="py-0">
                            <div class="text-center title font-weight-light">
                              <strong>{{$vuetify.lang.t('$vuetify.defaultLayout.username')}} :</strong>
                              {{ username }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      elevation="0"
                      class="px-10 ma-2 subtitle-1 text-capitalize font-weight-light button-primary"
                      @click="dialogFormUser = false"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.close')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogViewReport" scrollable max-width="900px">
                <v-card>
                  <v-toolbar flat dark color="rgb(51, 97, 137)">
                    <v-spacer></v-spacer>
                    <v-toolbar-title
                      class="font-weight-light text-center ml-5 text-capitalize"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.progressReport')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialogViewReport">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="px-0">
                    <v-container class="d-flex">
                      <v-col cols="5" class="px-5 pr-7">
                        <v-img
                          :src="image == null ? imageReady  : image"
                          class="my-2 ml-auto mr-auto rounded-card img-md"
                          aspect-ratio="1"
                          width="100%"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-icon
                                v-if="imageReady"
                                class="mx-auto"
                                elevation="3"
                                size="80"
                              >mdi-account</v-icon>
                            </v-row>
                          </template>
                        </v-img>
                        <v-row>
                          <v-col>
                            <span class="font-weight-bold title">{{fullName}}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0 font-weight-bold" cols="4">Username:</v-col>
                          <v-col class="py-0">
                            <span class="subtitle font-weight-light">{{userName}}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0 font-weight-bold" cols="4">Email:</v-col>
                          <v-col class="py-0">
                            <span class="subtitle font-weight-light">{{email}}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0 font-weight-bold" cols="4">Phone:</v-col>
                          <v-col class="py-0">
                            <span class="subtitle font-weight-light">{{tel}}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0 font-weight-bold" cols="4">Birthdate:</v-col>
                          <v-col class="py-0">
                            <span class="subtitle font-weight-light">{{birthdate}}</span>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0 font-weight-bold" cols="4">Gender:</v-col>
                          <v-col class="py-0">
                            <span class="subtitle font-weight-light">{{gender}}</span>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="7" class="px-0 pr-5">
                        <v-col cols="12" class="px-0 py-0">
                          <v-row class="mx-1">
                            <p
                              class="font-weight-bold black--text title text-capitalize pb-0 mb-0"
                            >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.progressReport')}}</p>
                          </v-row>
                          <v-row class="mx-1">
                            <p
                              class="font-weight-bold body-1 text-capitalize py-0 my-0"
                            >Course: {{ historyList.title }}</p>
                          </v-row>
                          <v-row class="mx-1">
                            <p
                              class="font-weight-light subtitle-2 py-0 my-0"
                              v-html="historyList.description"
                            />
                          </v-row>

                          <v-row
                            class="mt-5"
                            v-for="(section, sectionIndex) in historyList.learningSectionHis"
                            :key="sectionIndex"
                          >
                            <v-col class="py-0 mx-1">
                              <p
                                class="subtitle-2 font-weight-bold black--text"
                              >Lesson {{sectionIndex + 1}}: {{section.title}}</p>
                            </v-col>
                            <v-col
                              class="py-0"
                              cols="12"
                              v-for="(lecture, lectureIndex) in section.lectures"
                              :key="lectureIndex"
                            >
                              <div class="d-flex align-center">
                                <div class="pr-3">
                                  <v-icon v-if="lecture.type === 'PDF'">mdi-adobe-acrobat</v-icon>
                                  <v-icon
                                    v-else-if="lecture.type === 'EXAM'"
                                  >mdi-file-document-outline</v-icon>
                                  <v-icon
                                    v-else-if="lecture.type === 'BOOK'"
                                  >mdi-book-open-page-variant</v-icon>
                                  <v-icon v-else-if="lecture.type === 'VDO'">mdi-bell-ring-outline</v-icon>
                                  <v-icon v-else-if="lecture.type === 'YOUTUBE'">mdi-youtube</v-icon>
                                  <v-icon v-else-if="lecture.type === 'BLOG'">mdi-blogger</v-icon>
                                  <v-icon
                                    v-else-if="lecture.type === 'IMG'"
                                  >mdi-image-size-select-actual</v-icon>
                                  <v-icon v-else-if="lecture.type === 'FILE'">mdi-paperclip</v-icon>
                                  <v-icon v-else-if="lecture.type === 'URL'">mdi-link</v-icon>
                                </div>

                                <v-col>
                                  <v-row class="py-0">
                                    <span
                                      class="subtitle-2 font-weight-bold"
                                    >Lecture {{lectureIndex + 1}}: {{ lecture.title }}</span>
                                  </v-row>
                                  <v-row class="d-flex justify-between align-center py-0">
                                    <span>{{lecture.type}}</span>
                                    <v-spacer></v-spacer>
                                    <v-col class="text-right py-0 px-0">
                                      <v-btn
                                        v-if="lecture.type === 'EXAM' && lecture.percent > 0"
                                        color="success lighten-1 text-capitalize"
                                        small
                                        elevation="0"
                                        class="font-weight-light subtitle-2"
                                        @click="examTitle = lecture.title; dialogExamReport = true; getReportStudentExamScore(lecture.exam)"
                                      >Detail</v-btn>
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="lecture.percent == 100" class="align-center">
                                    <v-col class="d-flex px-0 py-0 align-center">
                                      <v-progress-linear
                                        :value="lecture.percent"
                                        color="success lighten-1"
                                        rounded
                                        height="8"
                                        reactive
                                      ></v-progress-linear>
                                      <v-icon
                                        small
                                        color="success lighten-1"
                                        class="ml-1"
                                      >mdi-check-circle</v-icon>
                                    </v-col>
                                  </v-row>
                                  <v-row v-else class="py-0 align-center">
                                    <v-col class="d-flex px-0 py-0 align-center">
                                      <v-progress-linear
                                        :value="lecture.percent"
                                        color="rgb(66, 154, 216)"
                                        background-color="grey lighten-3"
                                        rounded
                                        height="7"
                                        reactive
                                      ></v-progress-linear>
                                      <span class="ml-1">{{lecture.percent}}%</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </div>
                            </v-col>
                            <v-divider></v-divider>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-container>
                  </v-card-text>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      elevation="0"
                      class="px-10 ma-2 subtitle-1 text-capitalize font-weight-light button-primary"
                      @click="closeDialogViewReport"
                    >{{$vuetify.lang.t('$vuetify.courseManagement.close')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogExamReport" scrollable max-width="750px">
                <v-card>
                  <v-toolbar flat dark color="rgb(51, 97, 137)">
                    <v-spacer></v-spacer>
                    <v-toolbar-title
                      class="font-weight-light text-center ml-5 text-capitalize"
                    >Report Examination</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialogExamReport">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-col cols="12" class="pb-0 mt-3">
                      <p class="title black--text font-weight-bold">{{examTitle}}</p>
                    </v-col>
                    <v-col cols="12" class="py-0 d-flex align-center">
                      <p class="subtitle-2 mr-3">Full Score:</p>
                      <p>{{ fullScore }}</p>
                    </v-col>
                    <v-col cols="12" class="py-0 d-flex align-center">
                      <p class="subtitle-2 mr-3">Number of Questions:</p>
                      <p>{{ numOfQuestions }}</p>
                    </v-col>
                    <v-data-table
                      :loading="loading"
                      :headers="headerStudentExam"
                      :page.sync="page_student"
                      :items-per-page="limit_student"
                      @page-count="pageCount_student"
                      hide-default-footer
                      :items="studentReportExams"
                      class="py-5 ma-md-5 pt-0 mt-0font-weight-light"
                      elevation="3"
                    >
                      <template v-slot:top></template>
                      <template v-slot:item.num="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width text-left subtitle-2 font-weight-light"
                        >{{item.num}}</p>
                      </template>
                      <template v-slot:item.examDate="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width subtitle-2 font-weight-light"
                        >{{item.examDate}}</p>
                      </template>
                      <template v-slot:item.score="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width subtitle-2 font-weight-light"
                        >{{item.score}}</p>
                      </template>
                      <template v-slot:item.correct="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width subtitle-2 font-weight-light"
                        >{{item.correct}}</p>
                      </template>
                      <template v-slot:item.wrong="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width subtitle-2 font-weight-light"
                        >{{item.wrong}}</p>
                      </template>
                      <template v-slot:item.noAnswer="{ item }">
                        <p
                          class="ma-2 ml-0 md-fixed-width subtitle-2 font-weight-light"
                        >{{item.noAnswer}}</p>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogStatus" persistent max-width="450">
        <v-card>
          <v-card-title
            class="headline"
          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.confirmUnpublish')}}</v-card-title>
          <v-card-text>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.unpublishDescript')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2"
              large
              dark
              rounded
              outlined
              @click="closeDialogActive()"
            >{{$vuetify.lang.t('$vuetify.cancel')}}</v-btn>
            <v-btn
              color="error darken-1"
              class="px-10 ma-2"
              large
              dark
              rounded
              @click="userUpdateActive()"
            >{{$vuetify.lang.t('$vuetify.confirm')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogStatusActive" persistent max-width="450">
        <v-card>
          <v-card-title
            class="headline"
          >{{$vuetify.lang.t('$vuetify.courseManagement.courseList.confirmPublish')}}</v-card-title>
          <v-card-text>{{$vuetify.lang.t('$vuetify.courseManagement.courseList.publishDescript')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              class="px-9 ma-2"
              large
              dark
              rounded
              outlined
              @click="closeDialogActive()"
            >{{$vuetify.lang.t('$vuetify.cancel')}}</v-btn>
            <v-btn
              color="green darken-1"
              class="px-10 ma-2"
              large
              dark
              rounded
              @click="userUpdateActive()"
            >{{$vuetify.lang.t('$vuetify.confirm')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCantPublic" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">ไม่สามารถเผยแพร่คอร์สเรียนได้เนื่องจาก</v-card-title>
          <v-card-text>{{messageCantPublic}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              dark
              rounded
              @click="dialogCantPublic = false"
            >{{$vuetify.lang.t('$vuetify.confirm')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <div class="pt-3 pr-3 pb-5 text-center">
      <v-pagination v-model="params.page" :length="pageCount" color="rgb(66, 154, 216)"></v-pagination>
    </div>
  </div>
</template>
 
<script>
import {
  getReportCourse,
  getReportStudentInCourse,
  getReportStudentHistory,
  getRelatedCourse,
  getReportExamScore
} from "@/service/course/course";
import { uploadImage } from "@/service/upload/upload";
import { getUserEditByID } from "@/service/account/manageUser";
import { loadCategory } from "@/service/category/category";
import { loadSkill } from "@/service/skill/skill";
import ImportUserDialog from "@/views/course/users.vue";
import confirmTutorDialog from "@/views/user/confirmTutor.vue";
import { getRoom } from "@/service/room/room";
// import JsonExcel from "vue-json-excel";
// import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    ImportUserDialog,
    // JsonExcel,
    confirmTutorDialog,
    // VueApexCharts,
  },
  data: () => ({
    dialogFullReport: false,
    dialogViewReport: false,
    dialogFormUser: false,
    dialogExamReport: false,
    isEdit: false,
    image: null,
    searchCourseReport: null,
    searchStudentReport: null,
    courseId: "",
    studentId: "",
    roomId: "",
    fullName: "",
    room: "",
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    reportStudentList: [],
    historyList: [],
    historyExamList: [],
    students: [],
    chooseRoom: false,
    objCourse: [],
    knowledge: 0,

    instructorName: "",
    selectedRoom: "",
    roomsCourse: [],
    status_student_toggle: 0,
    status_toggle: 0,
    countStartedStudents: [],
    countNotStartedStudents: [],
    examTitle: "",
    fullScore: 0,
    numOfQuestions: 0,
    studentReportExams: [],

    alert: false,
    chooseSection: false,
    filterdialog: false,
    deleteDialog: false,

    userDialog: false,
    confirmDialog: false,
    registerTutoralert: false,

    loading: true,
    searchby: "ชื่อคอร์สเรียน",
    searchType: ["ชื่อคอร์สเรียน", "ชื่ออาจารย์"],
    sortType: [
      "เวลา สูง-ต่ำ",
      "เวลา ต่ำ-สูง",
      "ยอดนิยม สูง-ต่ำ",
      "ยอดนิยม ต่ำ-สูง",
    ],

    // series: [
    //   {
    //     name: "ข้อที่ถูก",
    //     data: [44, 55, 57, 56, 61,],
    //   },
    //   {
    //     name: "ข้อที่ถูก",
    //     data: [44, 55, 57, 56, 61,],
    //   },
    //   {
    //     name: "คะแนนของคุณ",
    //     data: [76, 85, 100, 98, 87]
    //   }
    // ],
    chartOptions: {
      chart: {
        type: "bar",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "50%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "ครั้งที่ 1",
          "ครั้งที่ 2",
          "ครั้งที่ 3",
          "ครั้งที่ 4",
          "ครั้งที่ 5",
        ],
      },
      // yaxis: {
      //   subtitle: {
      //     text: "คะแนน"
      //   }
      // },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " คะแนน";
          },
        },
      },
    },

    fileExcelName: "รายงานสรุปผลการสอบ.xls",
    dataForExcel: [
      { รายการสอบ: "Hello", colB: "World" },
      {
        colA: "Multi-line",
        colB:
          "This is a long paragraph\nwith multiple lines\nthat should show in a single cell.",
      },
      { colA: "Another", colB: "Regular cell" },
    ],

    headers: [
      {
        text: "Course Cover",
        align: "start",
        sortable: false,
        value: "image",
      },
      { text: "Course Name", align: "center", value: "title", sortable: false },
      { text: "Tutor Name", value: "ownerCourse", sortable: false },
      { text: "Categories", value: "category", sortable: false },
      // { text: "ราคา", value: "price", sortable: false },
      //   { text: "สถานะ", align: "center", value: "active", sortable: false },
      // {
      //   text: "จัดการผู้เรียน",
      //   align: "center",
      //   sortable: false,
      //   value: "actions",
      // },
      // {
      //   text: "รายงาน",
      //   align: "center",
      //   sortable: false,
      //   value: "report",
      // },
      // {
      //   text: "แก้ไขข้อมูลคอร์ส",
      //   align: "center",
      //   sortable: false,
      //   value: "edit",
      // },
      {
        text: "Action",
        align: "center",
        sortable: false,
        value: "edit",
      },
    ],
    // headerStudents: [
    //   {
    //     text: "รูปโปรไฟล์",
    //     align: "center",
    //     sortable: false,
    //     value: "image",
    //   },
    //   {
    //     text: "ชื่อ-นามสกุล",
    //     value: "fullName",
    //     align: "center",
    //     sortable: false,
    //   },
    //   { text: "อีเมล", value: "email", align: "center", sortable: false },
    //   {
    //     text: "ชื่อผู้ใช้งาน",
    //     value: "userName",
    //     align: "center",
    //     sortable: false,
    //   },
    //   { text: "ห้องเรียน", value: "room", align: "center", sortable: false },
    //   { text: "รายงาน", value: "report", align: "center", sortable: false },
    //   {
    //     text: "ข้อมูลผู้เรียน",
    //     value: "actions",
    //     align: "center",
    //     sortable: false,
    //   },
    // ],

    headerStudentExam: [
        {
          text: "Nº",
          align: "center",
          sortable: false,
          value: "num",
          width: "5%"
        },
        {
          text: "Exam Date",
          align: "center",
          sortable: false,
          value: "examDate",
          width: "50%"
        },
        {
          text: "Score",
          align: "center",
          sortable: false,
          value: "score"
        },
        {
          text: "Correct",
          align: "center",
          sortable: false,
          value: "correct",
          width: "10%"
        },
        {
          text: "Wrong",
          align: "center",
          sortable: false,
          value: "wrong",
          width: "10%"
        },
        {
          text: "No Answer",
          align: "center",
          sortable: false,
          value: "noAnswer",
          width: "20%"
        }
      ],

    headerStudents: [
      {
        text: "Profile Picture",
        align: "center",
        sortable: false,
        value: "image",
        width: "15%",
      },
      {
        text: "Full Name",
        value: "fullName",
        align: "start",
        sortable: false,
      },
      {
        text: "Progress",
        value: "progress",
        align: "start",
        sortable: false,
        width: "40%",
      },
      {
        text: "",
        value: "report",
        align: "center",
        sortable: false,
        width: "10%",
      },
    ],
    headersMockup: [
      {
        text: "วันที่",
        align: "center",
        sortable: false,
        value: "date",
      },
      {
        text: "เวลาที่ใช้งาน",
        align: "center",
        value: "timeLearn",
        sortable: false,
      },
      { text: "กิจกรรม", align: "center", value: "activity", sortable: false },
    ],
    historyItems: [
      {
        date: "4 เมษายน 2563",
        timeLearn: "03:00:00 ชม.",
        activity: "ดาราศาสตร์",
      },
      {
        date: "10 เมษายน 2563",
        timeLearn: "03:00:00",
        activity: "วิทยาศาสตร์ ชม.",
      },
    ],
    courses: [],
    searchdata: "",
    sortData: "เวลา สูง-ต่ำ",
    searchCourse: null,
    pageCount: 1,
    limit: 10,
    searchStudent: null,
    category: [],
    skill: [],
    selectedSkill: [],
    selectedCategory: [],
    active: "null",
    params: {},
    deleteItemID: [],

    isTeacher: "",
    reject_note: "",

    //user
    manageUserCourseID: "",

    //select dialog
    selectSectionDialog: false,
    section_headers: [
      {
        text: "ชื่อกลุ่ม",
        align: "start",
        sortable: false,
        value: "title",
      },
      { text: "ชื่ออาจารย์", value: "teacher", sortable: false },
      {
        text: "จำนวนผู้เรียน",
        value: "countStudent",
        sortable: false,
        align: "center",
      },

      {
        text: "เลือกกลุ่ม",
        sortable: false,
        align: "center",
        value: "select",
      },
    ],

    page_student: 1,
    limit_student: 50,
    pageCount_student: 1,
    // id: room._id,
    //teacher: room.teacher,
    //title: room.title,
    //countStudent: room.countStudent,
    //isPublic: room.isPublic,
    //permissionedit: room.permissionedit
    section_data: [],
    roomID: "",
    searchdataStudent: "",
  }),

  mounted() {
    this.initialize();
  },
  watch: {
    searchdata(keyword) {
      this.searchInfo(keyword);
    },
    searchdataStudent(keyword) {
      this.searchInfoStudent(keyword);
    },
  },
  computed: {
    fileRules() {
      const rules = [];

      if (this.lectureId === undefined) {
        const rule = (v) => !!v || "file is required";

        rules.push(rule);
      }

      return rules;
    },
  },
  methods: {
    initialize() {
      this.params = {
        searchCourse: this.searchCourse,
        searchStudent: this.searchStudent,
        sort: "created_at",
        sortby: 1,
        page: 1,
        limit: 1000,
        active: null,
        category: null,
        skill: null,
      };

      this.isTeacher = this.$store.state.isTeacher
        ? this.$store.state.isTeacher
        : "n";
      this.reject_note = this.$store.state.note ? this.$store.state.note : "";

      console.log("$store.state", this.$store.state);
      if (!this.$store.state.permission.viewCourse) {
        // this.registerTutoralert = true;
      } else if (!this.$store.state.permission.viewCourse) {
        // this.$store.state.isTeacher == "r" || this.$store.state.isTeacher == "w"
        //   ? (this.registerTutoralert = true)
        //   :
        this.noPermission();
      } else if (this.$store.state.permission.viewCourse) {
        // if (
        //   this.$store.state.isTeacher == "r" ||
        //   this.$store.state.isTeacher == "w"
        // ) {
        //   this.registerTutoralert = true;
        // } else {
        this.getCourseList();
        this.getCategoryList();
        this.getSkillList();
        this.getStudentCourseList();
        // }
      } else {
        this.getCourseList();
        this.getCategoryList();
        this.getSkillList();
        this.getStudentCourseList();
      }
      // this.$store.state.isTeacher == "n"
      // ? (this.registerTutoralert = true)
      //: (this.registerTutoralert = false);

      this.loading = false;

      this.searchdata = "";
      this.sortData = "เวลา สูง-ต่ำ";
      this.searchCourse = null;
      this.searchStudent = null;
      this.searchby = "ชื่อคอร์สเรียน";

      this.selectedSkill = [];
      this.selectedCategory = [];
      this.active = "null";
    },
    noPermission() {
      console.log("no permission");
      this.alert = true;
    },
    gotoDetail() {
      if (this.$store.state.permission.insertCourse) {
        this.$router.push({
          path: "/course/detail",
          query: { step: 1 },
        });
      } else {
        this.noPermission();
      }
    },
    onSort() {
      let index = this.sortType.indexOf(this.sortData);

      this.params.sortby = index % 2 == 0 ? -1 : 1;
      this.params.sort = index < 2 ? "created_at" : "countMylib";

      this.getCourseList();
    },

    editItem(item) {
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        let editCourse = this.courses[index];

        this.$router.push({
          path: "/course/detail",
          query: { id: editCourse.id, step: 1 },
        });
      } else {
        this.noPermission();
      }
    },
    deleteItem() {
      console.log("this.deleteItemID");
      this.deleteDialog = false;
      const index = this.courses.indexOf(this.deleteItemID);

      this.courses.splice(index, 1);
    },
    openModal(item) {
      this.deleteItemID = this.courses.indexOf(item);
      this.deleteDialog = true;
    },

    searchInfo(keyword) {
      this.params.search = keyword;

      this.getCourseList();
    },

    applyStudentFilter() {
      this.getStudentCourseList();
    },

    applyFilter() {
      this.filterdialog = false;
      let skills = this.selectedSkill.map((skill) => skill._id);
      let category = this.selectedCategory._id;

      this.params.skill = skills;
      this.params.category = category;
      this.params.active = this.active;
      this.getCourseList();
    },
    async getCourseList() {
      this.loading = true;

      let result = await getRelatedCourse(this.params);
      console.log("related course: ", result);
      this.courses = [];
      (this.pageCount = Math.ceil(result.length / this.limit)),
        result.forEach((course) => {
          this.courses.push({
            id: course._id,
            image: course.image,
            title: course.title,
            ownerCourse: course.owner_by_students,
            category: course.categories,
            price: course.prices,
            permissionEdit: course.permissionEdit,
          });
        });
      this.loading = false;
      console.log("related course list: ", this.courses);
    },

    async getCategoryList() {
      this.category = await loadCategory();
    },

    async getSkillList() {
      this.skill = await loadSkill();
    },
    //user
    async openUserModal(item) {
      console.log("openUserModal", item);
      let index = this.section_data.indexOf(item);
      this.roomID = this.section_data[index].id;
      this.userDialog = true;
      this.selectSectionDialog = false;
      // await this.getlistUser();
    },
    async CloseUserModal() {
      this.userDialog = false;
    },
    //section Modal
    setChooseRoom(item) {
      this.chooseRoom = true;
      this.objCourse = item;

      // this.courseId = item.id;
      if (this.chooseRoom == true) {
        this.openSectionModal(item);
      }
    },

    async opendialogExamReport(title) {
      this.dialogExamReport = true;
      this.examTitle = title;
    },

    closeDialogExamReport() {
      this.dialogExamReport = false;
      this.examTitle = "";
      this.fullScore = "";
      this.numOfQuestions = "";
      this.studentReportExams = [];
    },
    
    closeDialogViewReport() {
      // Clear Dialog View Report Data
      this.dialogViewReport = false;

      this.fullName = "";
      this.userName = "";
      this.email = "";
      this.tel = "";
      this.birthdate = "";
      this.gender = "";
      
      this.historyList = [];
    },

    setViewReport(item) {
      this.chooseRoom = true;
      this.objCourse = item;
      console.log("objCourse", this.objCourse);
      // this.courseId = item.id;
      if (this.chooseRoom == true) {
        this.openSectionModalReport(item);
      }
    },

    setChooseSection(item) {
      this.chooseRoom = false;
      this.chooseSection = true;
      if (this.chooseSection == true) {
        this.openSectionModal(item);
      }
    },

    async openSectionModalReport(item) {
      this.section_data = [];
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        this.manageUserCourseID = this.courses[index].id;
        let data = {
          idcourse: this.courses[index].id,
        };
        // this.selectSectionDialog = true;

        let result = await getRoom(data);
        // (this.pageCount_section = Math.ceil(result.length / this.limit)),
        result.forEach((room) => {
          this.section_data.push({
            id: room._id,
            teacher: room.teacher,
            title: room.title,
            countStudent: room.countStudent,
          });
        });

        this.section_data.map((section) => {
          this.roomsCourse.push(section.title);
        });
        this.openDialogGetReport(this.section_data);
        console.log("room", result);
      } else {
        this.noPermission();
      }
    },

    closeDialogFullReport() {
      this.dialogFullReport = false;

      // Clear Dialog Full Report Data
      this.imageCourse = "";
      this.title = "";
      this.courseId = "";
      this.instructorName = "";
      this.roomId = "";
      this.roomsCourse = [];
      this.section_data = [];
      this.selectedRoom = "";
      this.searchdataStudent = "";
      this.reportStudentList = [];
      this.status_student_toggle = 0;
    },

    async openSectionModal(item) {
      this.section_data = [];
      if (this.$store.state.permission.updateCourse) {
        let index = this.courses.indexOf(item);
        this.manageUserCourseID = this.courses[index].id;
        let data = {
          idcourse: this.courses[index].id,
        };
        this.selectSectionDialog = true;

        let result = await getRoom(data);
        (this.pageCount = Math.ceil(result.length / this.limit)),
          result.forEach((room) => {
            this.section_data.push({
              id: room._id,
              teacher: room.teacher,
              title: room.title,
              countStudent: room.countStudent,
            });
          });
        console.log("room", result);
      } else {
        this.noPermission();
      }
    },
    closeSectionModal() {
      this.selectedSection = [];
      this.selectSectionDialog = false;
    },
    openConfirmDialog() {
      this.registerTutoralert = false;
      this.confirmDialog = true;
    },
    async closeConfirmDialog() {
      this.confirmDialog = false;
      this.registerTutoralert = true;
    },

    //section report
    refreshFilter() {
      this.initialize();
    },
    // refreshStrudent() {
    //   this.initialize();
    // },

    refreshStudent() {
      // this.initialize();
      this.searchdataStudent = "";
      this.selectedRoom = "";
      this.status_student_toggle = 0;
      this.openDialogGetReport(this.section_data);
    },

    searchInfoCourse() {
      this.params.search = this.searchdata;
      this.getReportCourseList();
    },

    searchInfoStudent(keyword) {
      this.params.search = keyword;
      this.getStudentCourseList();
    },

    // async changePage(page) {
    //   this.params.page = page;
    //   await this.getCourseList();
    // },

    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.imgPreview = this.imgURL;
        this.imageReady = true;
        console.log("UPLOADED IMAGE:", this.imgPreview);
      } else {
        this.imageReady = false;
      }
    },

    async uploadImg(image) {
      let status = await uploadImage("user", image);
      return status;
    },

    async viewProgressReport(item) {
      this.dialogViewReport = true;
      this.image = item.image;
      this.fullName = item.fullName;
      this.email = item.email;

      this.courseId = this.objCourse.id;
      this.studentId = item.id;
      this.getReportHistory();
    },

    async openDialogGetReport(item) {
      this.dialogFullReport = true;
      this.imageCourse = this.objCourse.image;
      this.title = this.objCourse.title;
      this.courseId = this.objCourse.id;
      this.selectedRoom = this.roomsCourse[0];
      this.instructorName = item[0].teacher.displayName;
      this.roomId = item[0].id;
      this.getStudentCourseList();
    },

    async onChangeRoom() {
      let index = this.roomsCourse.indexOf(this.selectedRoom);
      // this.roomTitle = this.section_data[index].title;
      this.instructorName = this.section_data[index].teacher.displayName;
      this.roomId = this.section_data[index].id;
      // console.log("Selected Room:", this.section_data[index]);
      this.getStudentCourseList();
    },

    async getReportCourseList() {
      this.loading = true;
      let result = await getReportCourse(this.params);
      console.log("report list course", result);
      this.reportCourseList = [];
      result.forEach((course) => {
        this.reportCourseList.push({
          id: course._id,
          imageCourse: course.image,
          title: course.title,
          category: course.categories,
        });
      });
      this.imageReady = true;
      this.loading = false;
    },

    async getReportStudentExamScore(examId) {
      console.log("Report Exam Score");
      let result = await getReportExamScore({
        idexam: examId,
        idstudent: this.studentId
      });
      this.studentReportExams = [];
      this.fullScore = result.maxScore;
      this.numOfQuestions = result.countQuestion;
      let numExam = result.data.length + 1;
      result.data.forEach(reportExam => {
        numExam--;
        this.studentReportExams.push({
          num: numExam,
          examDate:
            new Date(reportExam.created_at).toDateString() +
            " " +
            new Date(reportExam.created_at).toLocaleTimeString(),
          score: reportExam.score,
          correct: reportExam.correct,
          wrong: reportExam.wrong,
          noAnswer: reportExam.noAnswer
        });
      });
      console.log("Report Exam Score", result);
    },

    async getStudentCourseList() {
      this.loading = true;
      let resultStudent = await getReportStudentInCourse({
        idcourse: this.courseId,
        idroom: this.roomId,
        search: this.params.search,
        page: this.page_student,
        limit: this.limit_student,
      });
      
      let result = [];
      this.countStartedStudents = resultStudent.data.filter(
        filter => filter.percent > 0
      );
      this.countNotStartedStudents = resultStudent.data.filter(
        filter => filter.percent == 0
      );

      if (this.status_student_toggle == 1) {
        result = resultStudent.data.filter(filter => filter.percent > 0);
      } else if (this.status_student_toggle == 2) {
        result = resultStudent.data.filter(filter => filter.percent == 0);
      } else {
        result = resultStudent.data;
      }
      console.log(result);
      this.reportStudentList = [];
      result.forEach((student) => {
        this.reportStudentList.push({
          id: student._id,
          image: student.image,
          fullName: student.firstName + " " + student.lastName,
          email: student.email,
          userName: student.username,
          tel: student.tel,
          birthdate: student.birthdate,
          gender: student.gender,
          room: student.room.title,
          percent: student.percent,
        });
      });
      this.imageReady = true;
      console.log(this.reportStudentList);
      this.loading = false;
      this.pageCount_student = resultStudent.maxPage;
    },

    async getReportHistory() {
      let result = await getReportStudentHistory({
        idcourse: this.courseId,
        idstudent: this.studentId,
      });
      console.log("history : ", result);
      this.historyList = result;
      this.historyExamList = [];
      this.knowledge = this.historyList.avgPercentAll;
      this.hisAvg = this.historyExamList.hisAvg;
      result.lectureExam.forEach((history) => {
        this.historyExamList.push({
          hisExamTitle: history.lecture.exams[0].title,
          hisExamType: history.type,
          hisAvg: history.avgScore,
          hisScore: history.getAllScore.map((term) => term.score),
          hisWrong: history.getAllScore.map((term) => term.wrong),
          hisCorrect: history.getAllScore.map((term) => term.correct),
          series: [
            {
              name: "คะแนนของคุณ",
              data: history.getAllScore.map((term) => term.score),
            },
          ],
          chartOptions: {
            // chart: {
            //   type: "bar"
            // },
            // plotOptions: {
            //   bar: {
            //     horizontal: false,
            //     columnWidth: "50%"
            //   }
            // },
            // dataLabels: {
            //   enabled: false
            // },
            // stroke: {
            //   show: true,
            //   width: 2,
            //   colors: ["transparent"]
            // },
            // grid: {
            //   row: {
            //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            //     opacity: 0.5
            //   }
            // },
            // xaxis: {
            //   categories: history.getAllScore.map((term, index) => index + 1)
            // },
            // fill: {
            //   opacity: 1
            // },
            // tooltip: {
            //   y: {
            //     formatter: function(val) {
            //       return val + " คะแนน";
            //     }
            //   }
            // }
            chart: {
              height: 350,
              type: "line",
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "straight",
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
          },
        });
      });
      console.log("log exam list : ", this.historyExamList);
      this.historyExamList.sort(function (a, b) {
        return b.hisScore.length - a.hisScore.length;
      });
      this.historyExamList.forEach((exam) => {
        console.log("คะแนนเฉลี่ย :", exam.hisAvg);
        let data = {
          รายการข้อสอบ: exam.hisExamTitle,
        };
        exam.hisScore.forEach((score, index) => {
          data[`ครั้งที่ ${index + 1}`] = score;
        });
        data[`คะแนนเฉลี่ย`] = exam.hisAvg;

        this.dataForExcel.push(data);
      });
      console.log(this.dataForExcel);
    },

    dowloadExcel() {
      console.log("dowload excel ", this.historyExamList);
      this.excelList = [];
      this.historyExamList.forEach((data) => {
        this.excelList.push({
          dataForExcel: [{ รายการสอบ: data.hisExamTitle }],
        });
      });
      // fileExcelName: "รายงานสรุปผลการสอบ.xls",
      //   dataForExcel: [
      //   { รายการสอบ: "Hello", colB: "World" },
      //   {
      //     colA: "Multi-line",
      //     colB:
      //       "This is a long paragraph\nwith multiple lines\nthat should show in a single cell."
      //   },
      //   { colA: "Another", colB: "Regular cell" }
      // ],
    },

    async getUserEdit(item) {
      console.log(this.isEdit);
      let result = await getUserEditByID({ idstudent: item.id });
      console.log("result ", result);
      this.editUserId = item.id;
      this.imgPreview = result.image;
      this.imageReady = true;
      this.firstName = result.firstName;
      this.lastName = result.lastName;
      this.email = result.email;
      this.username = result.username;
    },

    async userEdit(item) {
      this.dialogFormUser = true;
      this.imageReady = true;

      if (item) {
        this.isEdit = true;
        this.getUserEdit(item);
      } else {
        this.isEdit = false;
        this.$refs.form.resetValidation();
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.username = "";
      }
    },
  },
};
</script>
<style >
.main {
  background-color: rgb(241, 243, 245);
}

.page-card {
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.btn-reload {
  background: #ffffff !important;
  border: 1px solid #d9d9d9;
  color: rgb(77, 77, 77);
  box-shadow: none !important;
}

.text-primary {
  color: rgb(66, 154, 216) !important;
}

.text-field-border {
  border: 1px solid;
  border-radius: 8px;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}

.selectCourse {
  height: auto;
}
.fixed-heght {
  height: 30px;
}
.rounded-card {
  border-radius: 8px;
}
.v-text-field--filled > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 40px;
}
.v-input__append-inner {
  margin-top: 9px !important;
}
.md-fixed-max-width {
  max-width: 200px;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.apexcharts-toolbar {
  display: none;
}

@media only screen and (max-width: 768px) {
  .hiddex-xs {
    display: none;
  }
  .xs-full-max-width {
    max-width: 100%;
  }
  .md-fixed-width {
    width: 150px;
  }
  .xs-fixed-width {
    width: 100px;
  }
  .table-header {
    height: auto !important;
  }
  .table-header .v-toolbar__content {
    height: auto !important;
    flex-flow: column !important;
    padding: 0 !important;
  }
  .xs-full-width {
    width: 50%;
  }
}
.border-bottom {
  border-bottom: 1px solid #cfd8dc;
}
.border-bottom:last-child {
  border-bottom: none;
}
.full-width {
  width: 100%;
}
</style>
